import API from "../api/axios";

// ─── Get All Notifications ───
export const getAllNotifications = () => {
   return API.get("/notifications");
};

// ─── Mark Notification as Read ───
export const markNotificationAsRead = (id) => {
   return API.put(`/notifications/${id}/read`);
};

// ─── Clear All Notifications ───
export const clearAllNotifications = () => {
   return API.delete("/notifications/clear-all");
};